export default {"src":"/_next/static/media/stopwatch.02ad0b57.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};